import { appApis } from "../constants";
import reduxKeys from "../constants/reduxKeys";
import HttpClient from "./http-client";
import { getSoftwareProvider } from "./vehicles";

export const getInventoryFilters = () => {
    return (dispatch) => {
        new HttpClient().get(appApis.filters).then(response => {
            if(response?.data?.data){
                dispatch(getSuppliers());
                dispatch(getWareHouse());
                dispatch(getSoftwareProvider());
                dispatch({ type: reduxKeys.SET_INVENTORY_FILTERS, payload: response?.data?.data || {} });
            }
        }).catch(ex => {

        })
    }
}

export const getSuppliers = () => {
    return (dispatch) => {
        new HttpClient().get(appApis.suppliers).then(response => {
            if(response?.data){
                dispatch({ type: reduxKeys.SET_SUPPLIERS, payload: response?.data?.data || [] });
            }
        }).catch(ex => {

        })
    }
}

const getWareHouse = () => {
    return (dispatch) => {
        new HttpClient().get(appApis.wareHouse).then(response => {
            if(response?.data?.data){
                dispatch({ type: reduxKeys.SET_WAREHOUSE, payload: response?.data?.data?.warehouses || [] });
            }
        }).catch(ex => {

        })
    }
}

export const getInvetories = (payload) => {
    return new HttpClient().post(appApis.getInventory, payload);
}

export const getInvetoryCount = () => {
    return new HttpClient().get(appApis.getInventoryCount);
}

export const purchaseInventory = (payload) => {
    return new HttpClient().post(appApis.addInventory, payload);
}

export const getPurchaseInv = (query) => {
    return new HttpClient().get(`${appApis.addInventory}${query}`);
}

export const getInstallerInventory = (query) => {
    return new HttpClient().get(`${appApis.getInstallerInv}${query}`);
}

export const imeiAutoComplete = (query, type, state = null, installerId = null) => {
    return new HttpClient().get(`${appApis.imeiDetails}?imei=${query}&type=${type}&state=${state}${installerId ? `&installerId=${installerId}` : ""}`);
}

export const getInventoryLog = (invId, inventoryTypeId) => {
    return new HttpClient().get(`${appApis.inventoryLog}?id=${invId}&inventoryTypeId=${inventoryTypeId}`);
}

export const downloadInventoryData = (query) => {
    return new HttpClient().get(`${appApis.downloadData}${query}`);
}

export const addVehicle = (data, vehicleId) => {
    return vehicleId ? new HttpClient().put(`${appApis.updateRequest}?id=${vehicleId}`, data) : new HttpClient().post(`${appApis.addVehicleApi}`, data);
}

export const getMappingData = (query="") => {
    return new HttpClient().get(`${appApis.mappingCsv}?${query}`);
}